import React, {
  useState,
  useRef,
  useCallback,
  useMemo,
  useEffect,
} from 'react';
import { Modal, Button, message, Tooltip, Radio, Dropdown } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import {
  FileType,
  FolderTypeEnum,
  HeadersType,
  PermissionEnum,
  SearchType,
  SelectType,
  ShareType,
  TabKeyType,
  UserType,
} from '../types';
import {
  JoyspacePermissionType,
  getJoySpaceReadOnlyPermission,
} from '../config/permissions.config';
import styles from '../Share/index.module.less';
import ownerStyles from './index.module.less';
import { SearchIcon } from '../assets/icons/svg';
import { addShareUser, getShareUserNum, getUser } from '../api/user';
import { SearchGlobal } from '../Share/components/SearchGlobal';
import { getTabList } from '../utils/tab';
import Tab from '../Share/components/Tab';
import RightMembers from './comps/RightMembers';
import { getHeader } from '../utils';
import { sendFile } from '../api/file';
import { getWorkLineList } from '../api/ebook';

interface TabsType {
  title: string;
  key: TabKeyType;
}

interface IProps {
  id: string;
  isModalVisible: boolean;
  type: FileType;
  isExternalContacts: boolean;
  header?: HeadersType;
  activeKey?: TabKeyType;
  onCancel?: () => void;
  onConfirm?: (params: any, callback: Function) => void;
  events?: any;
  title?: string;
  titleTip?: string;
  isSelectUser?: boolean;
  isHasGroups?: boolean;
  cancelText?: string;
  okText?: string;
  width?: number;
  searchPlaceHolder?: string;
  tabs?: TabsType[];
  searchTabs?: TabsType[];
  maxSelectedNum?: number;
  isHasRecent?: boolean;
}

const params: any = {
  id: '', // 文档id
  dialogueMessage: ShareType.ShareMessage, // 通过会话分享
  type: FileType.Page, // 类型
  toGroups: [],
  toUsers: [],
  header: null,
};

export default function ShareUserModal(props: IProps) {
  const {
    id = '', // pageId | 必填
    isModalVisible = false, // 控制转所有者的弹出窗 | 必填
    type = FileType.Page, // 文档或者文件夹 | 必填
    isExternalContacts = false, // 是否是外部联系人 | 必填
    activeKey = TabKeyType.RecentlyContact, // 默认选择tab | 选填
    onCancel, // 弹窗关闭回调 | 选填
    events, // 事件订阅 | 选填
    onConfirm, // 接口请求成功回调函数 | 选填
    title = '', // 标题 | 选填
    titleTip = '', // 标题旁问号提示文字 | 选填
    isSelectUser = true, // 只选择人，不可选组、组织架构 | 选填
    isHasGroups = true, // 只选人情况下额外可以选组 | 选填
    cancelText = '取消', // 取消文字 | 选填
    okText = '确定', // 确定文字 | 选填
    width = 800, // modal宽度 | 选填
    searchPlaceHolder = '搜索', // 搜索placeholder | 选填
    tabs = [], // tabs | 选填
    searchTabs = [], // 搜索tabs | 选填
    maxSelectedNum = -1, // 最大选择人数 | 选填
    isHasRecent = true,
  } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [tabLoading, setTabLoading] = useState<boolean>(false);
  const [ackey, setActiveKey] = useState<TabKeyType>(activeKey);
  const [keyWord, setKeyWord] = useState<string>('');
  const [deptId, setDeptId] = useState<string>('');
  const [selectList, setSelectList] = useState<SelectType[]>([]);
  const [shareType, setShareType] = useState<ShareType>(ShareType.ShareMessage);
  // const [count, setCount] = useState<Number>(0);
  const [visibleSerch, setVisibleSerchModal] = useState(false);
  const [placeholder, setPlaceholder] = useState<string>(searchPlaceHolder);
  const hasWorkLine = useRef(false);
  const _tabs = useRef<TabsType[]>(tabs);
  console.log(tabs, '_tabs');
  const [_searchTabs, setSearchTabs] = useState<TabsType[]>(searchTabs);

  const handleDefaultKey = useCallback(() => {
    let defaultKey = TabKeyType.RecentlyContact;
    const curTabs = _tabs.current;
    if (curTabs.length > 0) {
      if (isExternalContacts) {
        // 外部联系人tab
        // const excludeKeys = [TabKeyType.Department, TabKeyType.WorkLine];

        const excludeKeys = [TabKeyType.Department];
        if (!isHasGroups) {
          excludeKeys.push(TabKeyType.Groups);
        }
        const tabIndex = curTabs.findIndex(
          item => !excludeKeys.includes(item.key)
        );
        if (tabIndex !== -1) {
          defaultKey = curTabs[tabIndex].key;
        }
      } else {
        defaultKey =
          activeKey !== TabKeyType.RecentlyContact ? activeKey : curTabs[0].key;
      }
    }
    setActiveKey(defaultKey);
  }, [isExternalContacts, _tabs.current, isHasGroups, activeKey]);

  const handleTabs = useCallback(() => {
    let newTabs = [..._tabs.current];
    console.log(newTabs, 'newTabs', _tabs.current);
    if (isExternalContacts) {
      newTabs = newTabs.filter(item => item.key !== TabKeyType.Department);
    }
    if (!hasWorkLine.current) {
      newTabs = newTabs.filter(item => item.key !== TabKeyType.WorkLine);
    }
    if (hasWorkLine.current) {
      const departIndex = newTabs.findIndex(
        item => item.key === TabKeyType.Department
      );
      const hasExisting = newTabs.some(
        item => item.key === TabKeyType.WorkLine
      );
      if (!hasExisting && departIndex !== -1) {
        newTabs.splice(departIndex + 1, 0, {
          title: '虚拟通讯录',
          key: TabKeyType.WorkLine,
        });
      }
    }
    _tabs.current = newTabs;
  }, [
    isExternalContacts,
    activeKey,
    _tabs.current,
    _searchTabs,
    hasWorkLine.current,
  ]);

  const handleSearchTabs = useCallback(() => {
    let newSearchTabs = [..._searchTabs];
    const hasTabAll = _searchTabs.find(item => item.key === TabKeyType.All);
    if (!hasTabAll) {
      newSearchTabs.unshift({ title: '全部', key: TabKeyType.All });
    }
    setSearchTabs(newSearchTabs);
  }, [_searchTabs]);

  const handlePlaceholder = useCallback(() => {
    if (isExternalContacts) {
      if (isHasGroups) {
        setPlaceholder('搜索');
      } else {
        setPlaceholder('搜索');
      }
    }
  }, [isExternalContacts, isHasGroups]);

  useEffect(() => {
    if (!isModalVisible) {
      return;
    }
    setTabLoading(true);
    // if (isExternalContacts) {
    //   _tabs.current.length !== 0 && handleTabs();
    //   _searchTabs.length !== 0 && handleSearchTabs();
    //   handleDefaultKey();
    //   handlePlaceholder();
    //   setTabLoading(false);
    // } else {
    getWorkLineList().then((res: any) => {
      const hasList = res?.deptInfoList
        ? res?.deptInfoList.length !== 0
        : false;
      hasWorkLine.current = hasList;
      _tabs.current.length !== 0 && handleTabs();
      _searchTabs.length !== 0 && handleSearchTabs();
      handleDefaultKey();
      handlePlaceholder();
      setTabLoading(false);
    });
    // }
  }, [isExternalContacts, isModalVisible]);

  // 底部
  const Footer = () => {
    return (
      <div className={styles['joyspace-share-modal-footer']}>
        <div className={styles['joyspace-share-modal-footer_l']}></div>
        <div className={styles['joyspace-share-modal-footer_r']}>
          <Button
            onClick={() => {
              setSelectList([]);
              setKeyWord('');
              onCancel?.();
              setVisibleSerchModal(false);
            }}
          >
            {cancelText}
          </Button>
          <Button
            type="primary"
            disabled={!selectList.length}
            loading={loading}
            onClick={() => {
              if (maxSelectedNum !== -1) {
                const maxLen =
                  selectList.filter(
                    (item: any) => item.type !== TabKeyType.Department
                  ).length > maxSelectedNum;
                if (maxLen) {
                  message.error(
                    `最多支持分享给${maxSelectedNum}个会话，请删减后重试`
                  );
                  setLoading(false);
                  return;
                }
              }
              onFinish();
            }}
          >
            {okText}
          </Button>
        </div>
      </div>
    );
  };

  const onFinish = async () => {
    setLoading(true);
    params.id = id;
    params.dialogueMessage = shareType;
    params.type = type;
    params.toUsers = [];
    params.toGroups = [];
    for (let item of selectList) {
      if (
        item.type === TabKeyType.Contact ||
        item.type === TabKeyType.RecentlyContact
      ) {
        params.toUsers.push({
          permission_type: item.permissionType,
          userId: (item as any).userId,
          teamId: (item as any).teamId || (item as any).tenantId,
          appId: (item as any).appId || (item as any).app,
        });
      } else if (item.type === TabKeyType.Groups) {
        params.toGroups.push({
          gid: item.id,
          permission_type: item.permissionType,
        });
      }
    }
    onConfirm?.(params, ({ status = false }) => {
      if (status) {
        setSelectList([]);
        setKeyWord('');
        setVisibleSerchModal(false);
      }
      setLoading(false);
    });
  };

  const selectDepartmentTab = useCallback((key, deptId = '') => {
    setActiveKey(key);
    setDeptId(deptId);
  }, []);
  const childRef = useRef<any>();
  // 点击复选框
  const onChangeCheck = useCallback(
    (item: any) => {
      if (!item) {
        return;
      }
      item.permissionType = getJoySpaceReadOnlyPermission();
      setSelectList((oldlList: any) => {
        if (item.checked) {
          oldlList.push(item);
          childRef.current && childRef.current.addUser(item);
        } else {
          const idx = oldlList.findIndex((_item: any) => _item.id === item.id);
          oldlList.splice(idx, 1);
          childRef.current && childRef.current.reomveUser(item);
        }
        return oldlList.concat();
      });
    },
    [selectList]
  );
  const onCheckAllChange = useCallback(
    (data: any[] = []) => {
      const _list = [...selectList];
      for (let item of data) {
        const idx = _list.findIndex(_item => _item.id === item.id);
        if (item.checked && idx === -1) {
          item.permissionType = getJoySpaceReadOnlyPermission();
          _list.push(item);
        } else if (!item.checked && idx > -1) {
          _list.splice(idx, 1);
        }
      }
      childRef.current && childRef.current.addUserAll(_list);
      setSelectList(_list);
    },
    [selectList]
  );
  const removeUserPermission = useCallback(
    item => {
      const _list = [...selectList];
      const index = _list.findIndex(_item => _item.id === item.id);
      if (index !== -1) {
        _list.splice(index, 1);
        setSelectList(_list);
      }
    },
    [selectList]
  );

  const getTitle = () => {
    return (
      <div className={styles['joyspace-share-header']}>
        {title}
        {titleTip && (
          <React.Fragment>
            <Tooltip
              placement="top"
              title={titleTip}
              overlayClassName={styles['joyspace-share-tooltip']}
            >
              <QuestionCircleOutlined />
            </Tooltip>
          </React.Fragment>
        )}
      </div>
    );
  };
  return (
    <Modal
      width={width}
      title={getTitle()}
      destroyOnClose={true}
      visible={isModalVisible}
      className={styles['joyspace-share-modal']}
      onCancel={() => {
        setActiveKey(ackey);
        setSelectList([]);
        onCancel?.();
        setKeyWord('');
        setVisibleSerchModal(false);
      }}
      footer={Footer()}
    >
      <div className={styles['joyspace-share-main']}>
        <div className={styles['joyspace-share-main-l']}>
          <SearchGlobal
            tab={getTabList({
              tabs: _searchTabs,
              isHasGroups,
              isExternalContacts,
              isSearch: true,
              hasWorkLine: hasWorkLine.current,
            })}
            isSelectUser={isSelectUser}
            isHasGroups={isHasGroups}
            visibleSerch={visibleSerch}
            id={id}
            isExternalContacts={isExternalContacts}
            placeholder={placeholder}
            selectList={selectList}
            onChangeKeyWord={(keyWord: string) => {
              setKeyWord(keyWord || '');
            }}
            isHasDep={!isExternalContacts}
            onChangeCheck={onChangeCheck}
            onCheckAllChange={onCheckAllChange}
            onvisibleSerch={() => {
              setVisibleSerchModal(false);
            }}
            selectDepartmentTab={selectDepartmentTab}
            maxSelectedNum={maxSelectedNum}
          ></SearchGlobal>
          <div className={styles['joyspace-share-search-container']}>
            <div
              className={styles['joyspace-share-search-container_input']}
              onClick={() => {
                setVisibleSerchModal(true);
              }}
            >
              <SearchIcon></SearchIcon>
              <span>{placeholder}</span>
            </div>
          </div>
          <Tab
            pageId={id}
            tabStyle={{ height: 'auto' }}
            tab={
              _tabs.current.length !== 0
                ? _tabs.current
                : getTabList({
                    isHasGroups,
                    isExternalContacts,
                    hasWorkLine: hasWorkLine.current,
                    isHasRecent,
                  })
            }
            isExternalContacts={isExternalContacts}
            acKey={ackey}
            selectList={selectList}
            isSelectUser={isSelectUser}
            isHasGroups={isHasGroups}
            deptId={deptId}
            onChangeCheck={(item: any) => {
              onChangeCheck(item);
            }}
            _onCheckAllChange={onCheckAllChange}
            maxSelectedNum={maxSelectedNum}
            tabLoading={tabLoading}
            selectDepartmentTab={selectDepartmentTab}
          />
        </div>
        <div className={styles['joyspace-share-main-r']}>
          <RightMembers
            selectList={selectList}
            removeUser={removeUserPermission}
            maxSelectedNum={maxSelectedNum}
          ></RightMembers>
        </div>
      </div>
    </Modal>
  );
}
